import React from 'react'
import './styles.scss'
import { Image, Link, CtaArrow } from 'newComponents'

const CaseStudiesList = ({ content }) => {
  const { title, tagline, caseStudies } = content

  return (
    <div className="bg-gradient">
      <div className="container case-studies-list-container">
        <div className="case-studies-list-header-container">
          <h2 className="case-studies-list-title">{title[0].text}</h2>
          <p className="case-studies-list-tagline">{tagline[0].text}</p>
        </div>
        <div className="case-studies-list">
          {caseStudies.edges.map((listItem) => {
            const {
              node: {
                url,
                company_name: companyName,
                data: {
                  headline: { text: headlineText },
                  logo
                }
              }
            } = listItem

            return (
              <div className="case-studies-list-item">
                <a href={`/case-studies${url}`}>
                  <div className="case-studies-list-item-inner">
                    <img alt={`${companyName} logo`} className="case-studies-list-item-logo" src={logo.url} />
                    <h4 className="case-studies-list-item-headline">{headlineText}</h4>
                    <span className="case-studies-list-item-link-text">
                      {companyName} Case Study <CtaArrow />
                    </span>
                  </div>
                </a>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default CaseStudiesList
